export const SchemaType = Object.freeze({
  ENTITY: 'Entity',
  COMMAND: 'Command',
  QUERY: 'Query',
  DOMAIN_EVENT: 'DomainEvent'
})

export const SchemaTypeLabels = Object.freeze({
  [SchemaType.ENTITY]: 'Entity',
  [SchemaType.COMMAND]: 'Command',
  [SchemaType.QUERY]: 'Query',
  [SchemaType.DOMAIN_EVENT]: 'Domain Event'
})

export const FieldType = Object.freeze({
  NORMAL: '',
  FILTER: 'filter'
})

export const DataType = Object.freeze({
  STRING: 'string',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  OBJECT: 'object'
})

export const DataTypeShortLabels = Object.freeze({
  [DataType.STRING]: 'S',
  [DataType.NUMBER]: 'N',
  [DataType.BOOLEAN]: 'B'
})

export const Cardinality = Object.freeze({
  ONE_TO_ONE: 'one-to-one',
  ONE_TO_MANY: 'one-to-many'
})

export const FIELD_CARDINALITY_OPTIONS = Object.freeze([
  { value: Cardinality.ONE_TO_ONE, label: '1 : 1' },
  { value: Cardinality.ONE_TO_MANY, label: '1 : N' }
])

export const QUERY_CARDINALITY_OPTIONS = Object.freeze([
  { value: Cardinality.ONE_TO_MANY, label: 'List' },
  { value: Cardinality.ONE_TO_ONE, label: 'Single Item' }
])

export const MAX_DESCRIPTION_LENGTH = 500
export const MAX_FIELD_DESCRIPTION_LENGTH = 256
